import PermissionsIcon from '@mui/icons-material/Lock';
import PermissionsList from './PermissionsList';
import PermissionsCreate from './PermissionsCreate';

export default {
  list: PermissionsList,
  create: PermissionsCreate,
  ICON: PermissionsIcon,
};